import { SvgIconType } from './svg.interface';

const Envelop: SvgIconType = ({
  width = 12,
  height = 9,
  className = '',
  color = '#3AA5DC'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 5.5475L12 0.5H0L6 5.5475Z" fill={color} />
    <path
      d="M12 8.75V2.44504L6.53278 7.06357C6.23853 7.31214 5.76147 7.31214 5.46723 7.06357L0 2.44504V8.75C0 9.16421 0.335786 9.5 0.75 9.5H11.25C11.6642 9.5 12 9.16421 12 8.75Z"
      fill={color}
    />
  </svg>
);

export default Envelop;
